import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton } from "@mui/material";
import LogoUam from "../../../assets/LogoUam.png";
import "./index.css";
import { AiOutlineSearch } from "react-icons/ai";

const Navbar = () => {
  const navigate = useNavigate();
  const [nav, setNav] = useState(false);
  const [openCatalog, setOpenCatalog] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const signup = true;

  const handleNav = () => {
    setNav(!nav);
  };
  // Abre el modal del catálogo
  const handleOpenCatalog = () => {
    setOpenCatalog(true);
  };

  // Cierra el modal
  const handleCloseCatalog = () => {
    setOpenCatalog(false);
  };

  // Maneja la búsqueda desde el modal
  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/resultados-busqueda?query=${searchQuery}`);
    setOpenCatalog(false);
  };

  return (
    <div className="big-container">
      <img src={LogoUam} className="react-text" />
      {/* <h1 className='react-text'>REACT.</h1> */}
      <ul className="navBar-list">
        <Link to={"/signin"} className="list-links">
          <li>Iniciar Sesión</li>
        </Link>
        <div className="list-links-especial" onClick={handleOpenCatalog}>
          <li>Catálogo</li>
        </div>
      </ul>
      <div onClick={handleNav} className="icono-menu">
        {nav ? (
          <AiOutlineClose
            size={20}
            color="black"
            className="responsive-closeIcon"
          />
        ) : (
          <AiOutlineMenu size={20} color="black" />
        )}
      </div>
      <div
        className={nav ? "mobile-list-container" : "mobile-list-container-dos"}
      >
        <img src={LogoUam} className="react-text" />
        <ul className="mobile-list">
          <Link to={"/signin"} className="list-links-mobile">
            <li>Iniciar Sesión</li>
          </Link>
          <div className="list-links-mobile" onClick={handleOpenCatalog}>
            <li>Catálogo</li>
          </div>
        </ul>
      </div>

      {/* Modal de Catálogo */}
      <Dialog
    open={openCatalog}
    onClose={handleCloseCatalog}
    fullWidth
    maxWidth="xs"  // Esto hace que el modal sea más ancho y responsivo
>
<DialogTitle
    variant="inherit"
    sx={{ textAlign: "center", fontWeight: "bold", fontSize: "1.5rem", color: "#0B545B" }}
  >
    Catálogo
  </DialogTitle>
  <DialogContent>
  <TextField
  autoFocus
  margin="dense"
  name="search"
  label="Buscar por título o autor"
  type="text"
  fullWidth
  variant="filled"
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
  sx={{
    '& .MuiFilledInput-root': {
      backgroundColor: "#f0f0f0",
    },
    '& .MuiInputLabel-root': {
      color: '#333',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#0B545B',
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-underline:hover:before': {
      borderBottom: 'none',
    },
  }}
/>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseCatalog} color="inherit">
      Cancelar
    </Button>
    <Button
      onClick={handleSearch}
      variant="contained"
      sx={{
        backgroundColor: "#0B545B",
        color: "#FFFFFF",
        "&:hover": { backgroundColor: "#21807C" }
      }}
    >
      Buscar
    </Button>
  </DialogActions>
</Dialog>

    </div>
  );
};

export default Navbar;
